var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("KCard", {
    staticClass: "k-skeleton-card",
    style: { height: _vm.height },
    attrs: {
      headingLevel: 2,
      isSkeleton: "",
      "aria-hidden": "true",
      title: "_",
      orientation: _vm.orientation,
      thumbnailDisplay: _vm.thumbnailDisplay,
      thumbnailAlign: _vm.thumbnailAlign,
    },
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function () {
          return [
            _c("span", {
              staticClass: "k-title-placeholder",
              style: { backgroundColor: _vm.$themePalette.grey.v_100 },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "belowTitle",
        fn: function () {
          return [
            _c("span", {
              staticClass: "k-below-title-placeholder",
              style: { backgroundColor: _vm.$themePalette.grey.v_100 },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }